<template>
  <component
    :is="navigateOnSelect ? 'internal-or-external-link' : 'div'"
    :href="navigateOnSelect ? siteHref : null"
    data-test-id="site-selector-card"
    @click="trackOrSelectSiteSelection()"
  >
    <q-card class="site-selector-card">
      <q-card-section
        class="no-padding"
        :horizontal="!navigateOnSelect"
      >
        <q-card-section
          v-if="!navigateOnSelect"
          class="no-padding"
        >
          <q-checkbox
            v-model="checked"
            class="q-mr-sm"
            @click.prevent="trackOrSelectSiteSelection()"
          />
        </q-card-section>
        <q-img
          :src="site.siteThumbnailImageUrl"
          :alt="`picture of ${site.name}`"
        />
        <q-card-section class="column q-pa-none">
          <div
            class="text-h6 text-center q-pa-sm"
            :class="cardColorCss"
            :style="{ 'background-color': cardColor === 'custom' ? cardColorHex : undefined }"
          >
            {{ site.name }}
            <q-item-label
              v-if="site.addressShort"
              class="text-subtitle2 q-py-sm"
            >
              {{ site.addressShort }}
            </q-item-label>
          </div>
        </q-card-section>
      </q-card-section>
    </q-card>
  </component>
</template>

<script>
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'
import { deletePrefix } from 'src/router/utils'

export default {
  name: 'SiteSelectorCard',
  components: {
    InternalOrExternalLink
  },
  configuration: ['currentSite'],
  props: {
    site: {
      type: Object,
      required: true
    },
    cardColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    cardColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    redirectHomePage: {
      type: Boolean,
      required: false,
      default: false
    },
    navigateOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedLocations: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['select', 'select-location'],
  data () {
    return {
      checked: false
    }
  },
  computed: {
    cardColorCss () {
      if (this.cardColor === 'custom') {
        return this.$isColorDark(this.cardColorHex) ? 'text-white' : 'text-black'
      } else if (this.cardColor === 'default') {
        return 'text-responsive bg-transparent'
      } else {
        return `bg-${this.cardColor} ${this.$getTextColor(this.currentSite, this.cardColor)}`
      }
    },
    siteHref () {
      if (this.redirectHomePage) {
        return this.$appendCurrentQueryParams(`${this.site.url()}?preferred`)
      }

      let currentPath = window.location.pathname
      if (this.currentSite.rootPath !== '/' && _.startsWith(currentPath, this.currentSite.rootPath)) {
        currentPath = deletePrefix(currentPath, this.currentSite.rootPath)
      }
      return this.$appendCurrentQueryParams(`${this.site.url(currentPath)}?preferred`)
    }
  },
  watch: {
    selectedLocations: {
      handler () {
        this.checked = _.some(this.selectedLocations, location => location.id === this.site.id)
      }
    }
  },
  mounted () {
    this.checked = _.some(this.selectedLocations, location => location.id === this.site.id)
  },
  methods: {
    trackOrSelectSiteSelection () {
      if (this.navigateOnSelect) {
        this.$trackEvent(this.$customerEvents.CLICKED_SITE_SELECTOR_ON_NAVIGATION)
        this.$emit('select')
      } else {
        this.$emit('select-location', this.site, this.checked ? 'add' : 'remove')
      }
    }
  }
}
</script>

<style scoped>
.site-selector-card {
  color: inherit;
  display: block;
  text-decoration: none;
}
</style>
